import CSS from './index.module.scss.js';
import React__default from 'react';
import classnames from 'classnames';
import { CategoryID } from '@sbt-web/network/types';
import { Verticals } from './categories.js';
import { getObserver } from './getObserver.js';
import { categoryHtmlIds, categoryMap, getCategoryFromHtmlId } from './config.js';

const categoriesObs = {};
const getCategory = (renderElement) => {
    //Get category from HTML id
    const cat = getCategoryFromHtmlId(renderElement.target.id);
    if (cat) {
        if (cat === 'immobili' && renderElement.intersectionRatio < 1) {
            delete categoriesObs[cat];
        }
        else {
            categoriesObs[cat] = renderElement.intersectionRatio;
        }
        //This code simply returns the item with the highest "intersection ratio" value
        const keys = Object.entries(categoriesObs);
        if (keys.length > 0) {
            const [lowestItems] = keys.sort(([, v1], [, v2]) => {
                return v2 - v1;
            });
            return lowestItems[0];
        }
    }
};
const generateMacroCategoriesList = function (currentSelectedCategoryId, categories, onClickCategory, mainCategory) {
    return (React__default.createElement(React__default.Fragment, { key: mainCategory?.id },
        mainCategory ? (React__default.createElement("button", { type: "button", className: classnames(CSS['cat-item-list'], CSS['cat-item-main-list'], mainCategory?.id === currentSelectedCategoryId
                ? CSS['selected-category']
                : null), value: mainCategory.id, onClick: () => onClickCategory(mainCategory) }, mainCategory.label)) : null,
        React__default.createElement("ul", { className: CSS['cat-list'] }, categories.map((cat) => (React__default.createElement("li", { key: cat.id },
            React__default.createElement("button", { type: "button", className: classnames(CSS['cat-item-list'], CSS['category-button'], {
                    [CSS['selected-category']]: cat.id === currentSelectedCategoryId,
                }), value: cat.id, onClick: () => onClickCategory(cat) }, cat.label)))))));
};
const CategoryList = function ({ setVerticalActive, setCategoryInput, assetsBase, selectedCategoryId, }) {
    /**
     * Observer callback:
     */
    const observeCb = React__default.useCallback((c) => {
        const cat = getCategory(c);
        if (cat) {
            setVerticalActive(cat);
        }
    }, [setVerticalActive]);
    /**
     * onClickCategory callback:
     */
    const onClickCategory = React__default.useCallback((cat) => {
        if (cat) {
            setCategoryInput({ key: cat.id, label: cat.label });
        }
    }, [setCategoryInput]);
    const motoriRef = React__default.useRef(null);
    const marketRef = React__default.useRef(null);
    const immobiliRef = React__default.useRef(null);
    const lavoroRef = React__default.useRef(null);
    const scrollableElementRef = React__default.useRef(null);
    /**
     * observe and unobserve element
     */
    React__default.useEffect(() => {
        const domElements = [
            motoriRef.current,
            immobiliRef.current,
            lavoroRef.current,
            marketRef.current,
        ];
        const observer = getObserver(scrollableElementRef.current, observeCb);
        domElements.forEach((element) => {
            if (element) {
                observer?.observe(element);
            }
        });
        return () => {
            domElements.forEach((element) => {
                if (element) {
                    observer?.unobserve(element);
                }
            });
            observer?.disconnect();
        };
    }, [observeCb]);
    return (React__default.createElement("div", { className: CSS['modal-dx-wrapper'] },
        React__default.createElement("span", { className: CSS['title-cat'] }, "Categoria"),
        React__default.createElement("div", { className: CSS['modal-dx-inner'], ref: scrollableElementRef },
            React__default.createElement("div", { id: categoryHtmlIds[categoryMap.motori], ref: motoriRef },
                React__default.createElement("span", { className: classnames(CSS['title-list'], CSS['cat-motori']) },
                    React__default.createElement("img", { src: `${assetsBase}/static/icons/category-selector/motori.svg`, alt: "Motori" })),
                generateMacroCategoriesList(selectedCategoryId, Verticals.Motori.categories, onClickCategory)),
            React__default.createElement("div", { id: categoryHtmlIds[categoryMap.market], ref: marketRef },
                React__default.createElement("span", { className: CSS['title-list'] },
                    React__default.createElement("img", { src: `${assetsBase}/static/icons/category-selector/market.svg`, alt: "Market" })),
                React__default.createElement("div", { className: CSS['cat-list-multi'] }, Verticals.Market.categories
                    .filter((cat) => cat !== Verticals.Market.default)
                    .map((cat) => generateMacroCategoriesList(selectedCategoryId, cat.categories ?? [], onClickCategory, cat)))),
            React__default.createElement("div", { id: categoryHtmlIds[categoryMap.immobili], ref: immobiliRef },
                React__default.createElement("span", { className: CSS['title-list'] },
                    React__default.createElement("img", { src: `${assetsBase}/static/icons/category-selector/immobili.svg`, alt: "Immobili" })),
                generateMacroCategoriesList(selectedCategoryId, Verticals.Immobili.categories, onClickCategory)),
            React__default.createElement("div", { id: categoryHtmlIds[categoryMap.lavoro], className: CSS['anchor-lavoro'], ref: lavoroRef },
                React__default.createElement("span", { className: CSS['title-list'] },
                    React__default.createElement("img", { src: `${assetsBase}/static/icons/category-selector/lavoro.svg`, alt: "Lavoro" })),
                generateMacroCategoriesList(selectedCategoryId, Verticals.Lavoro.categories, onClickCategory),
                React__default.createElement("div", { className: CSS['btn-all-cnt'] },
                    React__default.createElement("button", { id: "mobile-category-reset", onClick: () => onClickCategory({
                            label: 'Tutte le categorie',
                            id: CategoryID.Tutte,
                        }) }, "Cerca in tutte le categorie"))))));
};

export { CategoryList, generateMacroCategoriesList, getCategory };
//# sourceMappingURL=CategoryList.js.map
